// IE Hub - Tagline Text Component
// Reusable tagline component used across welcome/completion screens

import { Typography, TypographyProps } from '../ui';

interface TaglineTextProps {
  variant?: TypographyProps['variant'];
  sx?: TypographyProps['sx'];
}

export default function TaglineText({ 
  variant = 'h6', 
  sx = {} 
}: TaglineTextProps): JSX.Element {
  return (
    <Typography 
      variant={variant}
      sx={{ 
        opacity: 0.9,
        lineHeight: 1.6,
        ...sx
      }}
    >
      Your all-in-one solution for managing your finances with ease and confidence.
    </Typography>
  );
}
